import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm, FormsModule } from '@angular/forms';


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  constructor(private UserService: UserService) { }
  data: any;

  ngOnInit() {
  }
  ResetPasswordForm(form: NgForm) {

    this.UserService.resetpassword(form.value).subscribe(
      (data) => {
        this.data=data;
        console.log(this.data);
      }
    )

  }
}
